import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLACK_800, BLUE_500, Button, Divider, LILAC_400, Lottie, RightChevronIcon, Typography, WHITE, getTestId, useBreakpoint } from '@airtel/air-design-system';
import { Image, Pressable, View } from 'react-native';
import { getOfferCardWidgetStyles } from '../../OfferCardWidgetStyles';
import { SingleOfferCardWrapper } from '../single-offer-card-wrapper';
var Wrapper = props => {
  var children = props.children,
    isCardPressable = props.isCardPressable,
    cardPressMetaData = props.cardPressMetaData,
    onUserAction = props.onUserAction,
    id = props.id,
    _props$accessibilityP = props.accessibilityProps,
    accessibilityProps = _props$accessibilityP === void 0 ? {} : _props$accessibilityP;
  return _jsx(_Fragment, {
    children: isCardPressable ? _jsx(Pressable, Object.assign({
      onPress: () => {
        cardPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, cardPressMetaData), props));
      }
    }, accessibilityProps, {
      children: children
    })) : children
  });
};
export var SingleOfferCard = props => {
  var _props$heading = props.heading,
    heading = _props$heading === void 0 ? '' : _props$heading,
    _props$subHeading = props.subHeading,
    subHeading = _props$subHeading === void 0 ? '' : _props$subHeading,
    _props$ctaText = props.ctaText,
    ctaText = _props$ctaText === void 0 ? '' : _props$ctaText,
    ctaPressMetaData = props.ctaPressMetaData,
    _props$imageUrl = props.imageUrl,
    imageUrl = _props$imageUrl === void 0 ? '' : _props$imageUrl,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OfferCardWidget' : _props$testID,
    id = props.id,
    onUserAction = props.onUserAction,
    _props$numberOfLinesS = props.numberOfLinesSubHeading,
    numberOfLinesSubHeading = _props$numberOfLinesS === void 0 ? 1 : _props$numberOfLinesS,
    _props$showRightChevr = props.showRightChevron,
    showRightChevron = _props$showRightChevr === void 0 ? true : _props$showRightChevr,
    _props$showCard = props.showCard,
    showCard = _props$showCard === void 0 ? true : _props$showCard,
    _props$showShadow = props.showShadow,
    showShadow = _props$showShadow === void 0 ? true : _props$showShadow,
    style = props.style,
    rightContainerStyle = props.rightContainerStyle,
    leftContainerStyle = props.leftContainerStyle,
    _props$hideVerticalDi = props.hideVerticalDivider,
    hideVerticalDivider = _props$hideVerticalDi === void 0 ? false : _props$hideVerticalDi,
    lottieUrl = props.lottieUrl,
    _props$headingColor = props.headingColor,
    headingColor = _props$headingColor === void 0 ? BLACK_800 : _props$headingColor,
    _props$parentType = props.parentType,
    parentType = _props$parentType === void 0 ? 'GRADIENT' : _props$parentType,
    gradientType = props.gradientType;
  if (!heading && !subHeading) return _jsx(_Fragment, {});
  var offerWidgetStyles = getOfferCardWidgetStyles(props);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var imageSize = isSmallScreen ? 32 : 48;
  var noCardProps = {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    showShadow: false,
    withRoundedBorder: false
  };
  var leftContainer = _jsx(Image, Object.assign({
    source: {
      uri: imageUrl
    },
    style: {
      minHeight: imageSize,
      minWidth: imageSize
    }
  }, getTestId(testID, 'image')));
  if (imageUrl) {
    leftContainer = _jsx(Image, Object.assign({
      source: {
        uri: imageUrl
      },
      style: {
        minHeight: imageSize,
        minWidth: imageSize
      }
    }, getTestId(testID, 'image')));
  } else if (lottieUrl) {
    leftContainer = _jsx(Lottie, Object.assign({
      uri: lottieUrl,
      loop: true,
      style: {
        width: imageSize,
        height: imageSize
      }
    }, getTestId(testID, 'lottie')));
  }
  return _jsx(Wrapper, Object.assign({}, props, {
    children: _jsxs(SingleOfferCardWrapper, Object.assign({
      style: [offerWidgetStyles.container, style],
      parentType: parentType,
      showCard: showCard,
      showShadow: showShadow,
      noCardProps: noCardProps,
      gradientType: gradientType,
      testID: testID
    }, {
      children: [_jsxs(View, Object.assign({
        style: offerWidgetStyles.leftContainer
      }, {
        children: [_jsx(View, Object.assign({
          style: [offerWidgetStyles.leftImage, leftContainerStyle]
        }, {
          children: leftContainer
        })), !hideVerticalDivider && _jsx(Divider, {
          color: LILAC_400,
          height: 2,
          shadowColor: WHITE,
          isVertical: true
        })]
      })), _jsxs(View, Object.assign({
        style: [offerWidgetStyles.rightContainer, rightContainerStyle]
      }, {
        children: [_jsxs(View, Object.assign({
          style: {
            flex: 1
          }
        }, {
          children: [!!heading && _jsx(Typography, Object.assign({
            selectable: false,
            text: heading,
            type: "body-single-line-" + (isSmallScreen ? 'sm' : 'md') + "-bold",
            color: headingColor
          }, getTestId(testID, 'heading'))), !!subHeading && _jsx(Typography, Object.assign({
            selectable: false,
            text: subHeading,
            type: "body-para-" + (isSmallScreen ? 'xs' : 'sm'),
            color: BLACK_700,
            numberOfLines: numberOfLinesSubHeading,
            style: !isSmallScreen && offerWidgetStyles.subHeading
          }, getTestId(testID, 'subHeading'))), !!ctaText && _jsx(Button, Object.assign({
            title: ctaText,
            buttonType: "tertiary",
            onPress: () => {
              ctaPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
                id
              }, ctaPressMetaData), props));
            },
            style: offerWidgetStyles.button
          }, getTestId(testID, 'button')))]
        })), showRightChevron && _jsx(View, Object.assign({
          style: offerWidgetStyles.rightIcon
        }, {
          children: _jsx(RightChevronIcon, Object.assign({
            fontSize: isSmallScreen ? 20 : 24,
            color: BLUE_500
          }, getTestId(testID, 'RightChevronIcon')))
        }))]
      }))]
    }))
  }));
};